import { Component, inject } from '@angular/core';
import { TenantConfigService } from '../../../core/config/tenant-config';

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.html',
    styleUrl: './footer.scss',
})
export class Footer {
    public tenantConfigService = inject(TenantConfigService);
    public settings = this.tenantConfigService.settings;
    currentYear = new Date().getFullYear();

}
